export default __webpack_public_path__ + "static/media/graph4.1832ae40.png";